import { injectable } from "inversify";
import { rootContainer, TYPE } from "../container/root";
import { IApiResponse, IHttpService } from "../http-service";
import { IPolicyRule, IPolicyRulesSettingsPreset } from "../../pages/policies/policy-types";
import {WithOld} from "../../stores/types";

interface IPolicyRulesData {
    policy_rules: IPolicyRule[],
    settings: IPolicyRulesSettingsPreset
}

interface IPolicyRuleResponse {
    policy: IPolicyRule,
    should_refresh_list: boolean,
}

@injectable()
class PolicyRulesService {
    private readonly httpService: IHttpService = rootContainer.get<IHttpService>(TYPE.ApiHttp);

    async getPolicyRuleList(): Promise<IPolicyRulesData> {
        const res = await this.httpService.get<IApiResponse<IPolicyRulesData>>(`/rms-api/policy-rules`);
        return res.payload;
    }

    async updatePolicyRule(id: number, policy: WithOld<IPolicyRule>): Promise<IPolicyRuleResponse> {
        const res = await this.httpService.put<IApiResponse<IPolicyRuleResponse>>(`/rms-api/policy-rules/${id}`, policy);
        return res.payload;
    }

    async createPolicyRule(policy: IPolicyRule): Promise<IPolicyRuleResponse> {
        const res = await this.httpService.post<IApiResponse<IPolicyRuleResponse>>(`/rms-api/policy-rules/`, policy);
        return res.payload;
    }

    async deletePolicyRule(policyRuleId: number): Promise<boolean> {
        const res = await this.httpService.remove<IApiResponse<boolean>>(`/rms-api/policy-rules/${policyRuleId}`);
        return res.payload;
    }
}

export default PolicyRulesService;